/* eslint-disable default-case */
import React from 'react';
import { Notification } from 'rsuite';

type NotificationProps = {
  title: string;
  type: string;
  message: string;
  duration?: number;
};
export const showNotification = ({
  title,
  type,
  message,
  duration = 5000,
}: NotificationProps): null => {
  switch (type) {
    case 'success':
      Notification.success({
        title,
        description: <p>{message}</p>,
        duration,
      });
      break;
    case 'info':
      Notification.info({
        title,
        description: <p>{message}</p>,
        duration,
      });
      break;
    case 'error':
      Notification.error({
        title,
        description: <p>{message}</p>,
        duration,
      });
      break;
  }

  return null;
};
